export enum SuperTableAddRow {
    BALANCE = 'BALANCE',
    INCOME = 'INCOME',
    CALCULATION = 'CALCULATION',
    TITLE = 'TITLE',
    SPACE = 'SPACE',
    FREE_TEXT = 'FREE_TEXT',
    TEXT_ROW = 'TEXT_ROW',
    SEGMENT = 'SEGMENT',
    // FX (REV-21512): read-only rate row — offered only on FX reports; the source
    // (closing/average/position) is picked in a follow-up modal, like CALCULATION.
    RATE = 'RATE',
}
